import { CalculationKeynameEnum } from '../../enums/calculations/calculation-keyname.enum';
import { FileFillerInterface } from '../../interfaces/file-filler.interface';
import { CalculationResponse } from '../../responses/calculation.response';
import { Section84_1XlsxFiller } from '../xlsx-fillers/section-84_1.xlsx-filler';
import { SalaryDividendXlsxFiller } from '../xlsx-fillers/salary-dividend.xlsx-filler';

export class XlsxFillerFactory {
  constructor(
    private readonly section841XlsxFiller: Section84_1XlsxFiller,
    private readonly salaryDividendXlsxFiller: SalaryDividendXlsxFiller,
  ) {
  }

  getXlsxFiller(calculation: CalculationResponse): FileFillerInterface {
    switch (calculation.calculationKeyname) {
      case CalculationKeynameEnum.Section84_1: {
        return this.section841XlsxFiller;
      }
      case CalculationKeynameEnum.SalaryDividendSimulation: {
        return this.salaryDividendXlsxFiller;
      }
      // case CalculationKeynameEnum.Roulement:
      //     // return new Roulement(options);
      //     break;
      default:
        throw new Error(`Calculation ${calculation.calculationKeyname} is not supported`);
    }
  }
}
